import { format } from "date-fns";
import React from "react";

import InteractiveIcon from "assets/images/interactiveBidding.png";
import "./StudentTable.scss";
import BidPlayIcon from "assets/icons/courses/bidPlay.png";

interface Props {
  data: any;
  activeLesson?: number;
  onClickExercise?: (item: any, type?: "exercise" | "course") => void;
}

const StudentTable = ({ data, activeLesson, onClickExercise }: Props) => {
  const date = new Date();
  return (
    <div className="StudentTable-main">
      <table className="Table">
        <thead>
          <th scope="col">
            <div className="head-text-otr head-text-otr1">
              <p className="head-text">שם הקורס</p>
            </div>
          </th>
          <th scope="col">
            <div className="head-text-otr">
              <p className="head-text">התקדמות</p>
            </div>
          </th>
          <th scope="col">
            <div className="head-text-otr head-text-otr-last">
              <p className="head-text">תרגילים</p>
              <p className="head-text text-otr">
                <span className="text-inr">{format(date, "dd/MM/yyyy")}</span>
                <span className="text-inr">{format(date, "HH:mm")}</span>
              </p>
            </div>
          </th>
        </thead>
        <tbody>
          {data &&
            data.map((val: any) => {
              const results = val?.exercises?.reduce((acc: number, itemVal: any) => {
                if (itemVal?.mark === 1001) {
                  return acc + 1;
                }
                return acc;
              }, 0);

              const boofer: any[] = [];
              val?.exercises?.forEach((item: any) => {
                const date = new Date(item?.markUpdateDate || "");
                date.setMonth(date.getMonth() + 1);
                let className = "";
                let isDisabled = false;
                switch (activeLesson) {
                  case 1:
                    if (item?.mark === 1001) {
                      if (date < new Date()) {
                      }
                    } else {
                      return null;
                    }
                    break;
                  case 2:
                    if (item?.mark === 1001) {
                      if (date < new Date()) {
                        //
                      } else {
                        return null;
                      }
                    } else {
                      return null;
                    }
                    break;
                  case 3:
                    if (item.mark !== 1002) {
                      return null;
                    }
                    break;
                  case 4:
                    if (item?.mark !== 0) {
                      return null;
                    }
                }
                if (!item?.filteredEx) {
                  isDisabled = true;
                }
                if (activeLesson === 1) {
                  if (item?.mark === 1001) {
                    // if (date < new Date()) {
                    //   return null;
                    // }
                  } else {
                    return null;
                    isDisabled = true;
                  }
                }
                if (item?.mark === 1002) {
                  className = "red-bg";
                } else if (item?.mark === 1001) {
                  if (date < new Date()) {
                    className = "gradient-bg";
                  } else {
                    className = "green-bg";
                  }
                }
                boofer.push(
                  <li
                    style={{ cursor: "pointer" }}
                    className={`body-text body-text1 ${
                      isDisabled ? "disable-item-student-folder" : ""
                    } ${className}`}
                    key={`${item?.exId}_${item?.exIndex}_${val?.courseTitle}`}
                    onClick={() => onClickExercise && onClickExercise({ ...item, ...val })}>
                    <p>{item?.exIndex}</p>
                  </li>
                );
              });

              if (!boofer?.length) {
                return null;
              }

              return (
                <tr key={`${val?.courseId}_${val?.interactive}_${val?.bidPlay}_${val?.courseTitle}`}>
                  <td scope="col">
                    <div
                      className="body-text-otr body-text"
                      style={{ display: "flex", cursor: "pointer", alignItems: "center" }}
                      onClick={() => onClickExercise && onClickExercise(val, "course")}>
                      <p className="body-text" style={{ display: "flex", flex: 1 }}>
                        {val?.courseTitle}
                      </p>
                      {!!val?.interactive && !val?.bidPlay && (
                        <div>
                          <img src={InteractiveIcon} style={{ width: 40 }} />
                        </div>
                      )}
                      {!!val?.bidPlay && <img src={BidPlayIcon} style={{ width: 40 }} />}
                    </div>
                  </td>
                  <td scope="col">
                    <div className="body-text-otr">
                      <p className="body-text">
                        {results}/{val?.exercises?.length || 0} (
                        {Math.floor((results / val?.exercises?.length || 0) * 100)}%)
                      </p>
                    </div>
                  </td>
                  <td scope="col">
                    <div className="body-text-otr body-text-otr-last">
                      <ul className="body-text-ul">{boofer}</ul>
                    </div>
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>
    </div>
  );
};

export default StudentTable;
